import { connect } from 'react-redux'
import styled from 'styled-components'

import type { ClaimHandlerType } from '../claim/types'
import type { GlobalState } from '../types'
import type { UploadIdentityType } from './types'
import { getClaimHandlers, getIdentityValues } from './upload-selectors'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 10px 0 20px 0;
  justify-content: flex-start;
`
const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
`
const LabelInfo = styled.span`
 font-weight: bold;
 white-space: pre;
`

const LabelValue = styled.span`
  padding-left: 1.5rem;
`

const ClaimNumberLabelValue = styled(LabelValue)`
  padding-left: 6rem;
`

const NameLabelValue = styled(LabelValue)`
  padding-right: 1.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

const SubmitText = styled.div`
  height: 24%;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #515458;
  flex: 0 1 auto;
  @media (max-width: 568px) {
    margin-left:0%;
  }
`

type UploaderInfoProps = {
  claimNumber: string
  identity: UploadIdentityType
  claimHandlers: ClaimHandlerType[]
}

const UploaderInfoComponent = ({ claimNumber, identity, claimHandlers }: UploaderInfoProps) => (
  <Container>
    <Box>
      <LabelInfo>Claim Number</LabelInfo>
      <ClaimNumberLabelValue id="claimNumberValue">{claimNumber}</ClaimNumberLabelValue>
    </Box>
    <Box>
      <LabelInfo>Your Name or Business</LabelInfo>
      <NameLabelValue id="identityNameValue">{identity.name}</NameLabelValue>
    </Box>
    <Box>
      <SubmitText id='submit-text'>
          Use the {claimHandlers.length > 0
            ? 'drop down menus below to select a recipient and '
            : 'drop down below to '}
            describe the files being added. Select &quot;Submit Files&quot; when ready.
      </SubmitText>
    </Box>
  </Container>
)

const mapStateToProps = (state: GlobalState) => ({
  claimNumber: state.claim.claimDetails.claim,
  identity: getIdentityValues(state),
  claimHandlers: getClaimHandlers(state)
})

const UploaderInfo = connect(mapStateToProps)(UploaderInfoComponent)

export {
  UploaderInfo
}
